var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticStyle: { "font-size": "14px", "font-weight": "bold" } }, [
      _vm._v("\n    Material Type" + _vm._s(_vm.leftFlag) + "：\n  ")
    ]),
    _c("div", { staticClass: "temperature" }, [
      _c(
        "div",
        { staticClass: "mt-4 van-row flex" },
        [
          _c(
            "van-radio-group",
            {
              attrs: { direction: "horizontal" },
              on: { change: _vm.onMaterialChange },
              model: {
                value: _vm.value.materialType,
                callback: function($$v) {
                  _vm.$set(_vm.value, "materialType", $$v)
                },
                expression: "value.materialType"
              }
            },
            [
              _c(
                "van-radio",
                { attrs: { name: 1, "checked-color": "#8866f5" } },
                [_vm._v("SS316")]
              ),
              _c(
                "van-radio",
                { attrs: { name: 2, "checked-color": "#8866f5" } },
                [_vm._v("SS904")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.showBaseR
        ? _c("div", { staticStyle: { "margin-top": "20px" } }, [
            _vm._v("Base R1 = " + _vm._s(_vm.r1) + "Ω")
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "temperature-container" },
        [
          _c(
            "van-row",
            { attrs: { align: "center" } },
            [
              _c("van-col", { attrs: { span: "12" } }, [
                _c(
                  "div",
                  { staticClass: "flex-col-center" },
                  [
                    _c("div", [_vm._v("Temperature")]),
                    _c("van-stepper", {
                      staticStyle: { "margin-top": "10px" },
                      attrs: { step: "10", min: "0", max: "1000" },
                      on: {
                        change: function($event) {
                          return _vm.onTemperateChange("t")
                        }
                      },
                      model: {
                        value: _vm.value.temperature,
                        callback: function($$v) {
                          _vm.$set(_vm.value, "temperature", $$v)
                        },
                        expression: "value.temperature"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("van-col", { attrs: { span: "12" } }, [
                _c("div", { staticClass: "flex-col-center" }, [
                  _c("div", [_vm._v("Push Power(W)")]),
                  _c("div", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.number",
                          value: _vm.value.pushPower,
                          expression: "value.pushPower",
                          modifiers: { number: true }
                        }
                      ],
                      staticStyle: { width: "100px", "text-align": "center" },
                      domProps: { value: _vm.value.pushPower },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.value,
                              "pushPower",
                              _vm._n($event.target.value)
                            )
                          },
                          function($event) {
                            return _vm.onTemperateChange("p1")
                          }
                        ],
                        blur: function($event) {
                          return _vm.$forceUpdate()
                        }
                      }
                    })
                  ])
                ])
              ])
            ],
            1
          ),
          false
            ? _c(
                "van-row",
                {
                  staticStyle: { "margin-top": "16px" },
                  attrs: { align: "center" }
                },
                [
                  _c("van-col", { attrs: { span: "12" } }, [
                    _c("div", { staticClass: "flex-col-center" }, [
                      _c("div", [_vm._v("Proportion")]),
                      _c("div", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.number",
                              value: _vm.value.proportion,
                              expression: "value.proportion",
                              modifiers: { number: true }
                            }
                          ],
                          staticStyle: {
                            width: "100px",
                            "text-align": "center"
                          },
                          domProps: { value: _vm.value.proportion },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.value,
                                  "proportion",
                                  _vm._n($event.target.value)
                                )
                              },
                              function($event) {
                                return _vm.onTemperateChange("p2")
                              }
                            ],
                            blur: function($event) {
                              return _vm.$forceUpdate()
                            }
                          }
                        })
                      ])
                    ])
                  ]),
                  _c("van-col", { attrs: { span: "12" } }, [
                    _c("div", { staticClass: "flex-col-center" }, [
                      _c("div", [_vm._v("Integral")]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.number",
                            value: _vm.value.integral,
                            expression: "value.integral",
                            modifiers: { number: true }
                          }
                        ],
                        staticStyle: { width: "100px", "text-align": "center" },
                        domProps: { value: _vm.value.integral },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.value,
                                "integral",
                                _vm._n($event.target.value)
                              )
                            },
                            function($event) {
                              return _vm.onTemperateChange("i")
                            }
                          ],
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      })
                    ])
                  ])
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }